// SubscriptionStatus.js
import React from "react";

const SubscriptionStatus = ({ subscription, loading, error }) => {
  // Always show an error if one exists.
  if (error) {
    return <div>Error loading subscription status: {error}</div>;
  }

  // If we're loading and have no data, render nothing.
  if (loading && !subscription) {
    return null;
  }

  // If there's no subscription or subscription status is "none", show a default message.
  if (!subscription || subscription.status === "none") {
    return (
      <div style={{ textAlign: "left" }}>
        <p>You currently don’t have an active subscription.</p>
        <p>
          <strong>Subscribe now to unlock all features!</strong>
        </p>
      </div>
    );
  }

  let statusMessage;
  switch (subscription.status) {
    case "TRIALING":
      statusMessage = (
        <p>
          You’re on a trial! Enjoy Developer AI until{" "}
          <strong>{new Date(subscription.end_at).toLocaleDateString()}</strong>.
        </p>
      );
      break;
    case "ACTIVE":
      statusMessage = (
        <p>
          Your subscription is active and auto-renewing. Renewal date:{" "}
          <strong>{new Date(subscription.end_at).toLocaleDateString()}</strong>.
        </p>
      );
      break;
    case "EXPIRED":
      statusMessage = (
        <p>
          Your subscription expired on{" "}
          <strong>{new Date(subscription.end_at).toLocaleDateString()}</strong>.
        </p>
      );
      break;
    default:
      statusMessage = <p>Subscription Status: {subscription.status}</p>;
  }

  return (
    <div>
      <h3>Subscription Details</h3>
      {statusMessage}
    </div>
  );
};

export default SubscriptionStatus;
